import React from 'react';

function EmojiImage(props) {
    return (
      <div className="profile-initials profile-emoji">
        😎  
      </div>
    );
}

export default EmojiImage;
